import * as React from 'react';
export interface FormLabelInGridProps {
  classes?: string;
  htmlFor: string;
  label: string;
  required?: boolean;
}
export const FormLabelInGrid = ({
  classes = 'col-3 text-right pt-3',
  htmlFor,
  label,
  required = false,
}: FormLabelInGridProps) => {
  return (
    <div className={`col ${classes}`}>
      <label htmlFor={htmlFor}>
        {required && <span className="color-error">*</span>}
        {label}:
      </label>
    </div>
  );
};
